import { createModel } from "hox";
import useStorageState from "../hooks/useStorageState";
import { IPgProps, ISearchPage, ISelectOptions } from "@/types/ScmTypes";
import { PaginationProps } from "antd/es/pagination";
import { warehouseService, IWarehouseDetail, IShelfFileds } from "../views/base/warehouse/warehouseService"
import { IVRMSupplierDetail } from "../views/base/supplier/supplierService"
import { IVRMCustomerDetail } from "../views/base/customerFiles/customer/baseCustomerService"
import { IStockStatisticDetail } from "../views/stock/statistic/stockStatisticService"
import { ITechnicianDetail } from "../views/base/technician/technicianType"
import { IVehicleDetail } from "../views/base/customerFiles/vehicle/vehicleType"
import { IRoleDetail } from "../views/system/roles/rolesType"
import { beService } from "@/views/organization/entity/entityService";
import appService from "@/views/account/appService";

export function transPgToPagination(pg: IPgProps): PaginationProps {
    return {
        total: pg.total,
        pageSize: pg.size,
        current: pg.pageNum
    }
}
export type RoleType = {
    id: number,
    name: String,
};
export type UserType = {
    id: string,
    username: string,
    password: String,
    token: string,
    [key: string]: any

}

type GlobalModelType = {
    user: UserType,
    setUser: (e: UserType) => void,
    resetUser: () => void,
    toggleMenu: () => void,
    cm: CmType,
    resetCm: () => void
    beShopDs: ISelectOptions[],
    setBeShopDs: (value: ISelectOptions[] | ((previousState?: ISelectOptions[] | undefined) => ISelectOptions[])) => void
    [key: string]: any,
};


const initUserState = {
    id: "0",
    username: "admin",
    password: "",
    token: ""
}

type CmType = {
    collapsed: boolean
}
export interface RoleIdList {
    roleId: string, // "1362198473594294274",
    code: string, // "reckoner",
    name: string, // "结算员"
}
export interface ILanguageArr {
    "zh-CN": any,
    "en-US": any,
    [key: string]: any
}
export type ShopAndOrgType = {
    shopId: string,
    shopName: string,
    shopCode: string,
    orgCode: String,
    orgName: string
}
const initShopAndOrg = {
    shopId: "",
    shopName: "",
    orgCode: "",
    orgName: "",
    shopCode: ""
}
const initCmState = {
    collapsed: false
}
export type ISystemCode = "vrm-sa" | "vrm-nga" | string
export type ILanguage = "zh-CN" | "en-US"
//返回列表韦options的格式
export const transOptions = (list: any[]) => {
    return list.length != 0 ? list.map(item => ({ label: item.name, value: item.code })) : []
}
export const getFindItem = (code: string, list: any[]) => {
    return list.find(item => item.code === code)
}
function useModel(): GlobalModelType {
    const [user, setUser, resetUser] = useStorageState<UserType>('user', initUserState);
    const [shopAndOrg, setShopAndOrg, resetShopAndOrg] = useStorageState<ShopAndOrgType>('shopAndOrgNews', initShopAndOrg);
    const [authRoleIdList, setAuthRoleIdList] = useStorageState<RoleIdList[]>('authRole', []);
    const [menuAuth, setMenuAuth] = useStorageState<string[]>('authMenu', []);
    const [cm, setCm, resetCm] = useStorageState<CmType>('cm', initCmState);
    //仓库数据
    const [warehouseList, setWarehouseList, resetWarehouseList] = useStorageState<IWarehouseDetail[]>("warehouseList", []);
    //货位数据所有
    const [shelfList, setShelfList, resetShelfList] = useStorageState<IShelfFileds[]>("shelfList", []);
    //供应商数据
    const [supplieAllList, setsupplieAllList, resetsupplieAllList] = useStorageState<IVRMSupplierDetail[]>("supplieAllList", []);
    //客户列表数据
    const [CustomerData, setCustomerData, clearCustomerData] = useStorageState<IVRMCustomerDetail[]>("customerList", [])
    //车辆列表数据
    const [vehicleData, setVehicleData, clearVehicleData] = useStorageState<IVehicleDetail[]>("vehicleList", [])

    //库存列表数据
    const [stockData, setStockData, clearStockData] = useStorageState<IVRMCustomerDetail[]>("stockList", [])
    //维修技师数据
    const [technicianData, setTechniciankData, clearTechniciankData] = useStorageState<ITechnicianDetail[]>("technicianList", [])
    //角色列表
    const [rolesAllList, setRolesAllList, clearRolesAllList,] = useStorageState<IRoleDetail[]>("rolesAllLiat", [])
    const [beDs, setBeDs] = useStorageState<ISelectOptions[]>("vrm.beDs", []);
    //对应门店的经营实体
    // const [beShopDs, setBeShopDs] = useStorageState<ISelectOptions[]>("vrm.beShopDs", [{ label: "上海欧豪汽车贸易有限公司", value: "bentity.sh-ouhao" }, { label: "天津綦齿", value: "bentity.tj-qichi" }]);
    const [beShopDs, setBeShopDs] = useStorageState<ISelectOptions[]>("vrm.beShopDs", [{ label: "沙特NOR MOTORS", value: "Nor Motor Co.,Ltd." }]);
    //语言设置
    const [language, setLanguage, clearLanguage,] = useStorageState<ILanguage>("language", "zh-CN")
    //系统标识
    const [systemCode, setSystemCode,] = useStorageState<ISystemCode>("systemCode", "")
    //所有App系统分支
    const [appDs, setAppDs] = useStorageState<ISelectOptions[]>("fms.appDs", []);
    //加载所有仓库

    const loadWarehouseAllData = async () => {
        const params = {
            pageSize: 10000,
            pageNum: 1
        }
        let { retData } = await warehouseService.page(params);
        const { records, ...pg } = retData;
        const newRecords = records.map(item => ({
            ...item,
            // code: item.id,
            // codes: item.code
        }))
        setWarehouseList(newRecords)
    }
    const setLocale = (LanguageArr: ILanguageArr) => {
        return LanguageArr[language]
    }

    const toggleMenu = () => {
        setCm({
            ...cm,
            collapsed: !cm.collapsed
        })
    }
    //初始经营实体缓存
    const beLoadDataAll = async () => {
        const searchParams = {
            // ...defaultMdCmParam,
            // branch: "",
            "sourceApp": "vrm",
            page: {
                pageSize: 999999,
                pageNum: 1,
            }
        }
        // let { retData } = await beService.page(searchParams);
        // const { records } = retData;
        // setBeDs(records.map(item => ({
        //     id: item.key as string,
        //     label: item.name ?? "",
        //     value: item.code ?? ""
        // })));
    }
    //初始应用分支缓存
    const appLoadDataAll = async () => {
        let { retData } = await appService.find({});
        let appOptios = retData.map(item => ({
            label: item.name ?? "",
            value: item.code ?? "",
        }));
        setAppDs(appOptios);
    }

    return {
        user,
        setUser,
        resetUser,
        toggleMenu,
        cm,
        resetCm,
        warehouseList,
        setWarehouseList,
        loadWarehouseAllData,
        transOptions,
        supplieAllList,
        setsupplieAllList,
        resetsupplieAllList,
        CustomerData,
        setCustomerData,
        clearCustomerData,
        stockData,
        setStockData,
        clearStockData,
        shelfList,
        setShelfList,
        resetShelfList,
        technicianData,
        setTechniciankData,
        clearTechniciankData,
        vehicleData,
        setVehicleData,
        clearVehicleData,
        rolesAllList,
        setRolesAllList,
        clearRolesAllList,
        authRoleIdList,
        setAuthRoleIdList,
        language,
        setLanguage,
        setLocale,
        menuAuth,
        setMenuAuth,
        systemCode, setSystemCode,
        beDs, setBeDs,
        beShopDs, setBeShopDs,
        shopAndOrg, setShopAndOrg,
        beLoadDataAll,
        appLoadDataAll,
        appDs, setAppDs
    };
}

export const useGlobalModel = createModel(useModel)
export default useGlobalModel;
